module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.idLabel && !_vm.hiddenLabel) ? _c('label', [_vm._v("\n    " + _vm._s(_vm.idLabel) + "\n    "), (_vm.isMandatory) ? _c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "dropdown",
    attrs: {
      "id": 'dropdownContact-' + _vm.randomId
    }
  }, [_c('div', [_c('input', {
    staticClass: "form-control inputAccordionForm",
    class: _vm.errorIndicatorHighlight,
    style: ({
      height: _vm.customHeight !== 'none' ? _vm.customHeight + 'px' : 'calc(1.5em + 0.75rem + 2px)'
    }),
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholderValue,
      "autocomplete": "my-field-name"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "click": _vm.resetSelection,
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdownVisible()),
      expression: "showDropdownVisible()"
    }],
    staticClass: "dropdown-list",
    style: (_vm.dropdownStyle)
  }, _vm._l((_vm.itemListFiltered), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "dropdown-item itemContact",
      on: {
        "click": function($event) {
          return _vm.selectItem(item)
        },
        "mousedown": function($event) {
          return _vm.selectItem(item)
        }
      }
    }, [_c('div', [_c('label', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.identifier))])])])
  }), 0)])]), _vm._v(" "), (_vm.mandatoryErrorIndicator) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('errors.is_mandatory', {
    mandatoryValue: _vm.idLabel
  })) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-150eecd4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-150eecd4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/formContactDropdownLabelInput.vue
// module id = 2290
// module chunks = 2